// extracted by mini-css-extract-plugin
export default {"container":"User_container__4-jY9","requests_list":"User_requests_list__SNQLp"};